<app-modal [(visible)]="visible" header="ASSIGN TO: {{ assignmentTypeName }}" (visibleChange)="change($event)">
  <form-factory [formGroup]="formGroup" [model]="retrievalAssignmentNote"></form-factory>
  Changing retrieval type will clear out any previously scheduled dates and assignments. Please confirm you'd like to continue.
  <footer>
    <app-button class="header-button" text="ASSIGN" (onClick)="saveAssignNotes()"></app-button>
  </footer>
</app-modal>
